import { Link } from "react-router-dom";

const GRID = /^([A-Z])(\d{1,2})$/;

export const CellarMap = ({ locations }) => {
  const cells = {};
  locations.forEach((l) => {
    const m = GRID.exec(l.name);
    if (m) cells[`${m[1]}${Number(m[2])}`] = l;
  });
  const keys = Object.keys(cells);
  if (!keys.length) return null;
  const cols = [...new Set(keys.map((k) => k[0]))].sort();
  const maxShelf = Math.max(...keys.map((k) => Number(k.slice(1))));
  const shelves = Array.from({ length: maxShelf }, (_, i) => i + 1);
  const max = Math.max(1, ...Object.values(cells).map((l) => l.bottle_count));
  const total = Object.values(cells).reduce((s, l) => s + l.bottle_count, 0);

  return (
    <div className="rounded-xl border border-[#2E252A] bg-[#161214] p-5 mb-8 rise" data-testid="cellar-map">
      <div className="flex items-baseline justify-between mb-4">
        <p className="font-serif text-2xl text-[#F5F0EB]">Cellar map</p>
        <p className="font-mono text-xs text-[#6E665D]" data-testid="cellar-map-total">{total} bottles · {keys.length} places</p>
      </div>
      <div className="overflow-x-auto">
        <table className="border-separate border-spacing-1.5">
          <thead>
            <tr>
              <th />
              {cols.map((c) => <th key={c} className="font-mono text-xs text-[#D4AF37] font-normal pb-1">{c}</th>)}
            </tr>
          </thead>
          <tbody>
            {shelves.map((s) => (
              <tr key={s}>
                <td className="font-mono text-xs text-[#6E665D] pr-2 text-right">{s}</td>
                {cols.map((c) => <MapCell key={c} loc={cells[`${c}${s}`]} max={max} />)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-[#6E665D] mt-3">Columns are letters, shelves are numbers. Tap a place to see what it holds.</p>
    </div>
  );
};

const MapCell = ({ loc, max }) => {
  if (!loc) return <td><div className="w-16 h-12 rounded-md border border-dashed border-[#2E252A]" /></td>;
  const n = loc.bottle_count;
  const alpha = n ? 0.25 + 0.75 * (n / max) : 0;
  return (
    <td>
      <Link to={`/locations/${loc.id}`} title={loc.description || loc.name} data-testid={`map-cell-${loc.name}`}
        className="w-16 h-12 rounded-md border border-[#4A3B43] flex flex-col items-center justify-center hover:border-[#D4AF37] hover:-translate-y-0.5 transition-[border-color,transform] duration-200"
        style={{ backgroundColor: n ? `rgba(140, 43, 54, ${alpha})` : "#0D0A0B" }}>
        <span className="font-mono text-[10px] text-[#A89F91]">{loc.name}</span>
        <span className={`font-mono text-sm ${n ? "text-[#F5F0EB]" : "text-[#4A3B43]"}`} data-testid={`map-count-${loc.name}`}>{n}</span>
      </Link>
    </td>
  );
};
